import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import classnames from 'classnames';

const ariaTableDaysLabel =
  'Please choose a day of the month. Use the cursor to move around the table. Space or Enter will select.';

export default class DateTimePickerDays extends Component {
  static propTypes = {
    subtractMonth: PropTypes.func.isRequired,
    addMonth: PropTypes.func.isRequired,
    viewDate: PropTypes.object.isRequired,
    selectedDate: PropTypes.object.isRequired,
    showToday: PropTypes.bool,
    daysOfWeekDisabled: PropTypes.array,
    setSelectedDate: PropTypes.func.isRequired,
    showMonths: PropTypes.func.isRequired,
    minDate: PropTypes.object,
    maxDate: PropTypes.object,
    onShow: PropTypes.bool,
  };

  static defaultProps = {
    showToday: true,
  };

  generatedAriaTableLabel = () => {
    let label = `${ariaTableDaysLabel}`;

    if (this.props?.minDate) {
      label += `The minimum date selectable is ${this.props.minDate.format(
        'DD MMM YYYY'
      )}`;
    }

    if (this.props?.maxDate) {
      label += ` and the maximum date selectable is ${this.props.maxDate.format(
        'DD MMM YYYY'
      )}`;
    }

    return label;
  };

  renderDays = () => {
    var cells,
      classes,
      days,
      html,
      month,
      nextMonth,
      prevMonth,
      minDate,
      maxDate,
      row,
      year;
    year = this.props.viewDate.year();
    month = this.props.viewDate.month();
    prevMonth = this.props.viewDate.clone().subtract(1, 'months');
    days = prevMonth.daysInMonth();
    prevMonth.date(days).startOf('week');
    nextMonth = moment(prevMonth).clone().add(42, 'd');
    minDate = this.props?.minDate
      ? this.props.minDate.clone().subtract(1, 'days')
      : this.props.minDate;
    maxDate = this.props?.maxDate
      ? this.props.maxDate.clone()
      : this.props.maxDate;
    html = [];
    cells = [];

    while (prevMonth.isBefore(nextMonth)) {
      // let tabIndex = undefined; //this.props.onShow ? '0' : undefined;
      let tabIndex = this.props?.onShow ? '0' : undefined;
      classes = {
        day: true,
      };
      if (
        prevMonth.year() < year ||
        (prevMonth.year() === year && prevMonth.month() < month)
      ) {
        classes.old = true;
      } else if (
        prevMonth.year() > year ||
        (prevMonth.year() === year && prevMonth.month() > month)
      ) {
        classes.new = true;
      }
      if (
        prevMonth.isSame(
          moment({
            y: this.props.selectedDate.year(),
            M: this.props.selectedDate.month(),
            d: this.props.selectedDate.date(),
          })
        )
      ) {
        classes.active = true;
      }
      if (this.props.showToday) {
        if (prevMonth.isSame(moment(), 'day')) {
          classes.today = true;
        }
      }
      if (
        (minDate && prevMonth.isBefore(minDate)) ||
        (maxDate && prevMonth.isAfter(maxDate))
      ) {
        classes.disabled = true;
        tabIndex = undefined;
      }
      if (this.props.daysOfWeekDisabled.length > 0)
        classes.disabled =
          this.props.daysOfWeekDisabled.indexOf(prevMonth.day()) !== -1;
      cells.push(
        // <span>
        <td
          className={classnames(classes)}
          key={prevMonth.month() + '-' + prevMonth.date()}
          onClick={this.props.setSelectedDate}
          data-test-id="datepicker-day--cell"
          tabIndex={tabIndex}
          aria-label={prevMonth.format('dddd, Do MMMM YYYY')}
        >
          {prevMonth.date()}
        </td>
      );
      if (prevMonth.weekday() === moment().endOf('week').weekday()) {
        row = <tr key={prevMonth.month() + '-' + prevMonth.date()}>{cells}</tr>;
        html.push(row);
        cells = [];
      }
      prevMonth.add(1, 'd');
    }
    return html;
  };

  render() {
    const { onShow } = this.props;

    const tabIndex = onShow ? '0' : undefined;

    return (
      <div
        className="datepicker-days"
        aria-hidden={!onShow}
        style={{ display: onShow ? 'block' : 'none' }}
      >
        <table
          id="datepicker-days"
          className="table-condensed"
          aria-label={this.generatedAriaTableLabel()}
          data-test-id="datepicker--days-grid"
        >
          <thead>
            <tr>
              <th
                className="prev"
                onClick={this.props.subtractMonth}
                tabIndex={tabIndex}
                data-test-id="datepicker-prev--month"
                aria-label="Previous Month"
              >
                <span className="glyphicon glyphicon-chevron-left" />
              </th>

              <th
                className="switch"
                colSpan="5"
                onClick={this.props.showMonths}
                tabIndex={tabIndex}
                data-test-id="datepicker-show--months"
                aria-live="polite"
              >
                {moment.months()[this.props.viewDate.month()]}{' '}
                {this.props.viewDate.year()}
              </th>

              <th
                className="next"
                onClick={this.props.addMonth}
                tabIndex={tabIndex}
                data-test-id="datepicker-next--month"
                aria-label="Next Month"
              >
                <span className="glyphicon glyphicon-chevron-right" />
              </th>
            </tr>

            <tr>
              <th className="dow">Su</th>

              <th className="dow">Mo</th>

              <th className="dow">Tu</th>

              <th className="dow">We</th>

              <th className="dow">Th</th>

              <th className="dow">Fr</th>

              <th className="dow">Sa</th>
            </tr>
          </thead>

          <tbody>{this.renderDays()}</tbody>
        </table>
      </div>
    );
  }
}
